import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import moment from 'moment';
import { Constants } from './constants';
import { TranslateService } from '@ngx-translate/core';
import {isEmpty} from "./functions";
import {IdentificationType} from "./enums";

export function maxDateFromNow(
  translate: TranslateService,
  count: number,
  type: 'days' | 'weeks' | 'months' | 'years',
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const dateValue = moment(control.value, Constants.DATE_FORMAT);
    //Giới hạn ngày nhập phải nhỏ hơn {{count}} {{type}} tính từ thời điểm hiện tại
    if (!control.value || !dateValue.isValid() || !dateValue || Number.isNaN(count) || !type) {
      return null;
    }

    return dateValue.isSameOrBefore(moment().add(count, type).toDate(), 'day')
      ? null
      : {
          maxDateFromNow: {
            count: count,
            type: translate.instant(`validateError.fromNowType.${type}`),
          },
        };
  };
}

export function minDateToday(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const dateValue = moment(control.value, Constants.DATE_FORMAT);
    return !control.value || !dateValue.isValid() || dateValue.isSameOrAfter(moment(), 'day')
      ? null
      : { minDateToday: {} };
  };
}

export function maxDateToday(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const dateValue = moment(control.value, Constants.DATE_FORMAT);
    return !control.value || !dateValue.isValid() || dateValue.isSameOrBefore(moment(), 'day')
      ? null
      : { maxDateToday: {} };
  };
}

export function minDate(minDate: any, minDateLabel: any): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const dateValue = moment(control.value, Constants.DATE_FORMAT);
    if (!control.value || !dateValue.isValid()) return null;
    return dateValue.isSameOrAfter(minDate, 'day')
      ? null
      : { minDate: { minDateLabel: minDateLabel } };
  };
}

export function requiredLength(length: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (typeof control.value === 'string') {
      if (control.value.length !== length) {
        return {
          requiredLength: {
            requiredLength: length,
          },
        };
      } else {
        return null;
      }
    }
    return null;
  };
}

export function maxDate(maxDate: any, maxDateLabel: any): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const dateValue = moment(control.value, Constants.DATE_FORMAT);
    if (!control.value || !dateValue.isValid()) return null;
    return dateValue.isSameOrBefore(maxDate, 'day')
      ? null
      : { maxDate: { maxDateLabel: maxDateLabel } };
  };
}

export function minAtTheMoment(date: any, time: string): ValidationErrors | null {
  if (moment(date).isAfter(moment())) {
    return null;
  } else {
    if (moment(time, 'HH:mm').isSameOrBefore(moment())) {
      return { minAtTheMoment: {} };
    } else {
      return null;
    }
  }
}

export function onlyAlphabetAndNumber(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!isEmpty(control.value)) {
      if (control.value.match(Constants.Regex_AlphabetAndNumeric)) {
        return null;
      } else {
        return { pattern: {} };
      }
    } else {
      return null;
    }
  };
}

export function blockSpecialCharacter(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!isEmpty(control.value)) {
      if (control.value.match(Constants.Regex_BlockSpecialCharacter)) {
        return null;
      } else {
        return { pattern: {} };
      }
    } else {
      return null;
    }
  };
}

export function onlyNumber(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!isEmpty(control.value)) {
      let tmp = control.value;
      if (typeof control.value === 'number') {
        tmp = control.value.toString();
      }
      if (tmp.match(Constants.Regex_OnlyNumber)) {
        return null;
      } else {
        return { pattern: {} };
      }
    } else {
      return null;
    }
  };
}

export function identificationType(type: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (isEmpty(control.value)) {
      return null;
    }
    let tmp = control.value;
    if (
      type === IdentificationType.CCCD &&
      (tmp.length !== 12 || !tmp.match(Constants.Regex_OnlyNumber))
    ) {
      return {
        identificationType: {},
      };
    }
    if (
      type === IdentificationType.CMND &&
      (tmp.length !== 9 || !tmp.match(Constants.Regex_OnlyNumber))
    ) {
      return {
        identificationType: {},
      };
    }
    return null;
  };
}
